<form [formGroup]="locationForm" class="quantity-form">

  <div class="card-section">
    <div class="section-header">
      <h3>{{'pages.stock.add_stock.Product_locations' | translate}}</h3>
    </div>
    <div class="form-field form-field-full">
      <label for="quantity">{{'pages.stock.add_stock.locations' | translate}}*:</label>
      <div class="number-input-container">
        <input type="text" id="quantity" (keyup.enter)="addLocation()" formControlName="locationText"
          class="form-control" min="1" [placeholder]="('pages.stock.add_stock.locations' | translate) + '...'">
      </div>

      <div class="option-input-click" *ngIf="locationText?.value?.trim()" (click)="addLocation()">{{locationText.value}}
      </div>

      <div class="locations-tag-container" *ngIf="locations?.controls?.length">
        <div class="locations-tag" *ngFor="let tag of locations.controls; let i = index" (click)="removeLocation(i)">
          {{ tag.value }} X
        </div>
      </div>

    </div>
  </div>

  <div class="form-actions">
    <button type="button" class="btn btn-secondary" (click)="goBack()" [disabled]="isLoading">
      {{ 'common.back' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">
      <span *ngIf="isLoading" class="loading-spinner"></span>
      {{ 'pages.stock.edit.save_changes' | translate }}
    </button>
  </div>
</form>